import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'showValue' })
export class ShowValuePipe implements PipeTransform {
    transform(value: any, ...args: any[]): any {
        return typeof value === 'number' ? value : '';
    }
}

